import Url from '../global/Url';
import { getCsrf } from './auth';

/** Lee la configuración de asignación de Fusión (pool de asesoras + modo automático). */
export async function getConfigFusion() {
    const r = await fetch(Url.Api + 'fusion/config', { headers: { Accept: 'application/json' } });
    const data = await r.json();
    if (!r.ok || data.header !== 'OK') throw new Error(data.message || 'No se pudo cargar la configuración');
    return data;
}

/** Guarda la configuración. { asesoras:[{gestor_id,agent,en_manual,en_automatico,orden}], modo_auto, auto_fija_gestor } */
export async function guardarConfigFusion(config) {
    const r = await fetch(Url.Api + 'fusion/config', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF': getCsrf() || '' },
        body: JSON.stringify(config),
    });
    const data = await r.json();
    if (!r.ok || data.header !== 'OK') throw new Error(data.message || 'No se pudo guardar');
    return data;
}
